class TogglePasswordHidden {
    setup() {
        this.toggleBuntton = this.$refs.toggle;
        this.inputPassword = this.$refs.input;
        this.iconButton = this.$refs.icon;
        this.classIcon = this.$opts.classicon;
        this.showPassword = this.inputPassword.getAttribute('type') === 'text';
        this.toggleBuntton.addEventListener('click', this.toggleHandle.bind(this));

        if (this.iconButton) {
            this.classIconDefautl = this.iconButton.getAttribute('class');
        }
    }
    toggleHandle() {
        this.showPassword = !this.showPassword;
        this.inputPassword.setAttribute('type', this.showPassword ? 'text' : 'password');
        this.toggleBuntton.setAttribute('show-password', this.showPassword);

        if (this.iconButton && this.classIcon) {
            this.iconButton.setAttribute('class', this.showPassword ? this.classIcon : this.classIconDefautl);
        }
    }
}

export default TogglePasswordHidden;